import React from "react";
import { useNavigate } from "react-router-dom";
import { Facebook, Twitter, Instagram, ExternalLink } from "lucide-react";
import styles from "./CSS/Footer.module.css";
import { useLinks } from "../../hooks/admin/useAdminLinks";

const Footer = () => {
  const navigate = useNavigate();
  const { links } = useLinks();

  const getSocialUrl = (platform) => {
    const link = links?.find(l => l.platform === platform);
    return link?.url || null;
  };

  const handleSocialClick = (platform, defaultUrl) => {
    const customUrl = getSocialUrl(platform);
    window.open(customUrl || defaultUrl, "_blank");
  };

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.logoSection}>
          <img 
            src="/images/logo/newlogo.png" 
            alt="logo" 
            className={styles.logoImage} 
          />
        </div>
        <div className={styles.allLinksContainer}>
          <div className={styles.linksSection}>
            <div className={styles.linkGroup}>
              <h3>Home</h3>
              <ul>
                <li onClick={() => navigate("/shortstories/hindi")}>Short Stories</li>
                <li onClick={() => navigate("/reading")}>Reading</li>
                <li onClick={() => navigate("/video")}>Video</li>
                <li onClick={() => navigate("/about")}>About</li>
                <li onClick={() => navigate("/blogs")}>Blogs</li>
              </ul>
            </div>

            <div className={styles.linkGroup}>
              <h3>Useful Links</h3>
              <ul>
                <li onClick={() => navigate("/")}>Home</li>
                <li onClick={() => navigate("/contact-us")}>Contact Us</li>
                <li onClick={() => navigate("/refund-policy")}>Refund Policy</li>
                <li onClick={() => navigate("/privacy-policy")}>
                  Privacy Policy
                </li>
                <li onClick={() => navigate("/terms")}>Terms & Conditions</li>
              </ul>
            </div>
          </div>

          <div className={styles.socialSection}>
            <h3>Follow Us</h3>
            <div className={styles.socialIcons}>
              <Facebook
                className={styles.icon}
                onClick={() => handleSocialClick("facebook", "https://facebook.com")}
              />
              <Twitter
                className={styles.icon}
                onClick={() => handleSocialClick("twitter", "https://twitter.com")}
              />
              <Instagram
                className={styles.icon}
                onClick={() => handleSocialClick("instagram", "https://instagram.com")}
              />
            </div>
            <div className={styles.support}>
            <h3>Support</h3>
            <p
              className={styles.emailLink}
              onClick={() => {
                const email = getSocialUrl("gmail") || "support@sunokahaniyan.com";
                window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${email}`, "_blank");
              }}
            >
              {getSocialUrl("gmail") || "support@sunokahaniyan.com"}
            </p>
          </div>
          </div>
        </div>
      </div>
      <div className={styles.footerBottom}>
        <p>Copyright © 2025, All Right Reserved</p>
      </div>
    </footer>
  );
};

export default Footer;